module.exports = __webpack_public_path__ + "media/icons/map-icon-zoom-out-23b4a811.svg";